import axios from "axios";
import "bijou/base";
import "bijou/jquery-ui";
import {
  setAddressFields,
  manualEntryClickListeners,
} from "./loqate_address/address_fields_handling";
import {
  handleErrorResponse,
  removeErrorMessage,
  LoqateApiError,
} from "./loqate_address/error_handling";

const LOQATE_FIND_API_URL =
  "https://api.addressy.com/Capture/Interactive/Find/v1.10/json3.ws";
const LOQATE_RETRIEVE_API_URL =
  "https://api.addressy.com/Capture/Interactive/Retrieve/v1.2/json3.ws";
const REQUEST_DELAY = 50; // delay in milliseconds between when a keystroke occurs and when a find request is made

// ======== API call functions =======

const findPossibleAddresses =
  (key, state, countryCode) => (input, updateSuggestions) => {
    const Text = input.term.trim();
    if (!Text.length) return {};

    const stateFilter = state ? `AdministrativeArea:${state}` : null;

    return axios
      .get(LOQATE_FIND_API_URL, {
        params: {
          Key: key,
          Text,
          Countries: countryCode,
          Filters: stateFilter,
        },
      })
      .then((response) => {
        removeErrorMessage();

        const { Items } = response.data;
        const firstItem = Items[0];
        if (firstItem && firstItem.Error) {
          throw new LoqateApiError(firstItem);
        } else {
          const addresses = serializeSuggestions(Items, input.term.length);
          updateSuggestions(addresses);
        }
      })
      .catch((e) => handleErrorResponse(e));
  };

const retrieveAddress = (key) => (_event, ui) =>
  axios
    .get(LOQATE_RETRIEVE_API_URL, { params: { Key: key, Id: ui.item.id } })
    .then((response) => {
      const firstItem = response.data.Items[0];
      if (firstItem && firstItem.Error) {
        throw new LoqateApiError(firstItem);
      } else {
        setAddressFields(serializeAddressData(response));
      }
    })
    .catch((e) => handleErrorResponse(e));

// ======== Serialize data functions =======

const serializeSuggestions = (items, searchLength) => {
  const addresses = items.filter((item) => item.Type === "Address");

  if (!addresses.length) {
    return [{ label: "empty", value: "empty", noResults: true, searchLength }];
  }

  return addresses.map((loqateAddressData) => {
    const { Text, Id, Highlight } = loqateAddressData;
    return {
      label: highlightAddress(Highlight, Text),
      value: Text,
      id: Id,
    };
  }, []);
};

const serializeAddressData = (response) => {
  const loqateAddressData = response.data.Items[0];

  const addressLine1 =
    `${loqateAddressData.BuildingNumber} ${loqateAddressData.Street}`.trim() ||
    loqateAddressData.Line1;
  const addressLine2 = loqateAddressData.SubBuilding;

  return {
    street: addressLine1,
    subBuilding: addressLine2,
    city: loqateAddressData.City,
    provinceName: loqateAddressData.ProvinceName,
    adminAreaName: loqateAddressData.AdminAreaName,
    postalCode: loqateAddressData.PostalCode.split("-")[0],
  };
};

const highlightAddress = (highlight, text) => {
  if (!highlight) return text;

  const portionsToHighlight = highlight.split(",").reverse();

  portionsToHighlight.forEach((portionToHighlight) => {
    const [start, end] = portionToHighlight.split("-");

    text =
      text.slice(0, start) + text.slice(start, end).bold() + text.slice(end);
  });

  return text;
};

// ======= Initialize jQuery Autocomplete widget functions =======

const customizeAutocompleteInput = (selector) => {
  // disable Chrome browser autofill on search field
  const backoffice = $("body").hasClass("backoffice");
  if (navigator.vendor.includes("Google") && !backoffice) {
    $(selector).attr("autocomplete", "nope");
  }
  // reshow suggestions when clicking back into search field
  $(selector).on("click", ({ target }) => {
    const suggestionsMenu = $(".address-autocomplete-group .ui-autocomplete");
    if ($(target).val() && suggestionsMenu.children().length) {
      $(".address-autocomplete-group .ui-autocomplete").show();
    }
  });
};

const customizeAutocompleteMenu = (selector) => {
  const instance = $(selector).autocomplete("instance");
  instance.widget().menu("option", "items", "> li");

  const rendermenu = instance._renderMenu;
  instance._renderMenu = function (ul, items) {
    const { noResults, searchLength } = items[0];

    if (noResults && searchLength <= 10) {
      ul.append(
        "<div class='no-results type-more'>Please keep typing to locate your address.</div>",
      );
    } else if (noResults) {
      ul.append(
        "<div class='no-results'>" +
          "We do not recognize this address, please try again " +
          "<span class='enter-manually' role='button'>or enter your address manually.</span></div>",
      );
    } else {
      rendermenu.call(this, ul, items);
      focusOnFirstSuggestion(instance, ul);
    }
    ul.append("<div class='enter-manually' role='button'>Enter manually</div>");
  };
};

const focusOnFirstSuggestion = (instance, ul) =>
  instance.widget().menu("focus", null, ul.children().first());

const customizeAutocompleteItem = (selector) => {
  const instance = $(selector).autocomplete("instance");

  instance._renderItem = function (ul, item) {
    return $("<li>")
      .append($('<div class="ui-menu-item-wrapper">').html(item.label))
      .appendTo(ul);
  };
};

const loqateAddressAutocomplete = (selector) => {
  if (!$(selector).length) return;

  const { key, stateCode, country } = $(selector).data();

  manualEntryClickListeners();

  $(selector).autocomplete({
    source: findPossibleAddresses(key, stateCode, country),
    appendTo: $(selector).parent(),
    delay: REQUEST_DELAY,
    select: retrieveAddress(key),
  });

  customizeAutocompleteInput(selector);
  customizeAutocompleteItem(selector);
  customizeAutocompleteMenu(selector);
};

export {
  findPossibleAddresses,
  highlightAddress,
  retrieveAddress,
  loqateAddressAutocomplete,
};
